module.exports = __webpack_public_path__ + "img/pwa-windows-2.c2df2f69.jpg";